var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableTennis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M144,78.3H0V81h30.9L20.5,91.4c-2,2-2,5.3,0,7.3s5.3,2,7.3,0L45.4,81h3.6L7.8,122.3c-2,2-2,5.3,0,7.3c2,2,5.3,2,7.3,0 L63.6,81H144V78.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.3,
    cy: 37.3,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7,37.1h18.4l7.9,7.9L39,73.1h32.7l11.7-11.7l10.2,10.2c1,1,2.3,1.5,3.6,1.5h20.6c1.3,0,2.6-0.5,3.6-1.5 c1.7-1.7,2-4.2,0.8-6.2l1.9-1.9c1.6,1.2,3.5,1.8,5.4,1.8c2.3,0,4.7-0.9,6.4-2.6c3.5-3.5,3.5-9.3,0-12.8l0,0 c-3.5-3.5-9.3-3.5-12.8,0c-3.2,3.2-3.5,8.3-0.9,11.8l-1.9,1.9c-0.8-0.4-1.7-0.7-2.5-0.7H99.5L64.9,28.3c-0.9-0.9-2.2-1.5-3.6-1.5 H40.7c-2.8,0-5.1,2.3-5.1,5.1S37.9,37.1,40.7,37.1z M125.2,51.7c1.2-1.2,2.9-1.9,4.5-1.9s3.3,0.6,4.5,1.9c2.5,2.5,2.5,6.5,0,9 c-2.5,2.5-6.5,2.5-9,0C122.8,58.2,122.8,54.2,125.2,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.7,41.1c2.9,0,5.2-2.3,5.2-5.2s-2.3-5.2-5.2-5.2s-5.2,2.3-5.2,5.2C124.6,38.8,126.9,41.1,129.7,41.1z M129.7,33.5 c1.3,0,2.4,1.1,2.4,2.4s-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4C127.3,34.6,128.4,33.5,129.7,33.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTennis);
export default __webpack_public_path__ + "static/media/tableTennis.0103b1b0328d8c1d58d28a80f826527a.svg";
export { ForwardRef as ReactComponent };